import React from 'react';
import Error from '../components/Error/Error';

const NotFoundView = () => <Error error="404" />;

export default NotFoundView;
